<template>
    <v-card
        :class="getClasses()"
        :outlined="this.outlined"
        :flat="this.flat"
    >
        <v-icon 
            v-if="icon && !$vuetify.breakpoint.smAndDown" 
            :size="icon.size" 
            color="primary" 
            class="px-4 py-4 align-start"
        >
            {{ icon.name }}
        </v-icon>
        <div v-if="icon && !$vuetify.breakpoint.smAndDown">
            <card-content-factory
                v-for="element in elements"
                :key="element.type"
                :content="element"
            />
        </div>
        <template v-else>
            <card-content-factory
                v-for="element in elements"
                :key="element.type"
                :content="element"
            />
        </template>
    </v-card>
</template>

<script>
import CardContentFactory from "./CardContentFactory.vue";

export default {
    components: {
        CardContentFactory
    },
    props: {
        elements: Array,
        main: Boolean,
        medium: Boolean,
        outlined: Boolean,
        flat: Boolean,
        icon: Boolean
    },
    methods: {
        getClasses() {
            let def = "card text-center";

            if(this.main && !this.medium) {
                def += " main-card";
            }
            if(this.icon && !this.$vuetify.breakpoint.smAndDown) {
                def += " icon-card";
            }
            if(this.medium) {
                def += " medium-card";
            }

            return def;
        }
    }
}
</script>

<style lang="scss">
.card {
  font-family: "Roboto";
  padding-top: 0px;
}

.icon-card {
  display: flex;
}

.icon-card > div {
  width: 100%;
}

.v-card__title {
  word-break: keep-all;
  text-align: left;
}

.main-card {
  .v-card__title {
    font-weight: 300;
    @include main-card-title;
  }

  .v-card__text {
    text-align: justify;
    color: rgba(0, 0, 0, 0.6);
    font-weight: 300;
    padding: 0px 16px 16px 16px;
    @include main-card-text;
  }
}

.medium-card {
  .v-card__title {
    font-weight: 400;
    word-break: keep-all;
    text-align: left;
    @include medium-card-title;
  }

  .v-card__text {
    text-align: justify;
    color: rgba(0, 0, 0, 0.6);
    font-weight: 300;
    padding: 0px 16px 16px 16px;
    @include medium-card-text;
  }
}
</style>